import { SearchDocumentInstanceHistory } from './SearchDocumentInstanceHistory.component'

import { withCompose } from '../SearchDocumentHistory.container'

export default withCompose(SearchDocumentInstanceHistory)
